const isSuperFormControlLabel = (props) => props.icon != null;
export {
  isSuperFormControlLabel
};
//# sourceMappingURL=utils.es.js.map
